
import EmailListInput from "./EmailListInput.vue";
import ItensEnvioChecklist from "./ItensEnvioChecklist.vue";
import {
  ENVIO_CONTABILIDADE_DEFAULT_FORM,
  ENVIO_CONTABILIDADE_PERIODO_LABELS,
} from "@/modules/envio-contabilidade/utils";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "EnvioContabilidadeConfigFormModal",
  components: {
    EmailListInput,
    ItensEnvioChecklist,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    itens: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.novoForm(),
      errors: {},
    };
  },
  computed: {
    titulo() {
      return this.value && this.value.id
        ? "Editar configuração"
        : "Nova configuração";
    },
    periodoOptions() {
      return Object.keys(ENVIO_CONTABILIDADE_PERIODO_LABELS).map(value => ({
        value,
        text: ENVIO_CONTABILIDADE_PERIODO_LABELS[value],
      }));
    },
    spedFiscalSelecionado() {
      return Boolean(this.form.itens && this.form.itens.sped_fiscal);
    },
    perfilSpedOptions() {
      const spedFiscal = this.itens.find(item => item.key === "sped_fiscal");
      const options =
        spedFiscal &&
        spedFiscal.configuration &&
        Array.isArray(spedFiscal.configuration.options)
          ? spedFiscal.configuration.options
          : [];

      if (options.length > 0) {
        return options.map(option => ({
          value: option.value,
          text: option.label,
        }));
      }

      return ["A", "B", "C"].map(value => ({
        value,
        text: `Perfil ${value}`,
      }));
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.resetar();
      }
    },
    value: {
      handler() {
        if (this.show) {
          this.resetar();
        }
      },
      deep: true,
    },
  },
  methods: {
    novoForm() {
      return {
        ...ENVIO_CONTABILIDADE_DEFAULT_FORM,
        emails: [],
        cc: [],
        bcc: [],
        itens: {},
      };
    },
    resetar() {
      const base = this.value ? { ...this.value } : this.novoForm();
      this.form = {
        ...this.novoForm(),
        ...base,
        emails: [...(base.emails || [])],
        cc: [...(base.cc || [])],
        bcc: [...(base.bcc || [])],
        horario: "07:00",
        itens: this.normalizarItens(base.itens || {}),
        perfil_sped: base.perfil_sped || "B",
      };
      this.errors = {};
    },
    normalizarItens(itensSelecionados) {
      const itens = {};

      this.itens.forEach(item => {
        itens[item.key] = Boolean(itensSelecionados[item.key]);
      });

      Object.keys(itensSelecionados || {}).forEach(key => {
        if (!Object.prototype.hasOwnProperty.call(itens, key)) {
          itens[key] = Boolean(itensSelecionados[key]);
        }
      });

      return itens;
    },
    state(field) {
      if (!Object.prototype.hasOwnProperty.call(this.errors, field)) {
        return null;
      }

      return false;
    },
    validarEmails(field, required = false) {
      const emails = this.form[field] || [];

      if (required && emails.length === 0) {
        return "Informe ao menos um destinatário válido.";
      }

      const invalido = emails.find(email => !EMAIL_REGEX.test(email));

      if (invalido) {
        return "Informe um e-mail válido.";
      }

      return "";
    },
    validar() {
      const errors = {};
      const diaMes = Number(this.form.dia_mes);

      if (!this.form.nome) {
        errors.nome = "Informe o nome da rotina.";
      }

      const emailsError = this.validarEmails("emails", true);
      if (emailsError) {
        errors.emails = emailsError;
      }

      const ccError = this.validarEmails("cc");
      if (ccError) {
        errors.cc = "Informe um e-mail válido para cópia.";
      }

      const bccError = this.validarEmails("bcc");
      if (bccError) {
        errors.bcc = "Informe um e-mail válido para cópia oculta.";
      }

      if (!diaMes || diaMes < 1 || diaMes > 31) {
        errors.dia_mes = "O dia do mês deve ser entre 1 e 31.";
      }

      if (!this.form.periodo) {
        errors.periodo = "Informe o período da competência.";
      }

      const possuiItem = Object.keys(this.form.itens || {}).some(
        key => this.form.itens[key]
      );

      if (!possuiItem) {
        errors.itens = "Selecione pelo menos um item para envio.";
      }

      if (
        this.spedFiscalSelecionado &&
        !["A", "B", "C"].includes(this.form.perfil_sped)
      ) {
        errors.perfil_sped = "Selecione o perfil do SPED Fiscal.";
      }

      this.errors = errors;

      return Object.keys(errors).length === 0;
    },
    salvar() {
      if (!this.validar()) {
        return;
      }

      this.$emit("save", {
        ...this.form,
        dia_mes: Number(this.form.dia_mes),
        horario: "07:00",
      });
    },
  },
};
